/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface InitialSavedState
 */
export interface InitialSavedState {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   *
   */
  savedState: string;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly uuid?: string;
}

/**
 * Check if a given object implements the InitialSavedState interface.
 */
export function instanceOfInitialSavedState(value: object): value is InitialSavedState {
  if (
    (!("savedState" in (value as Record<string, any>)) &&
      !("saved_state" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["savedState"] === undefined &&
      (value as Record<string, any>)["saved_state"] === undefined)
  )
    return false;
  return true;
}

export function InitialSavedStateFromJSON(json: any): InitialSavedState {
  return InitialSavedStateFromJSONTyped(json, false);
}

export function InitialSavedStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): InitialSavedState {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    savedState: json["saved_state"],
    id: json["id"] == null ? undefined : json["id"],
    uuid: json["uuid"] == null ? undefined : json["uuid"],
  };
}

export function InitialSavedStateToJSON(json: any): InitialSavedState {
  return InitialSavedStateToJSONTyped(json, false);
}

export function InitialSavedStateToJSONTyped(
  value?: Omit<InitialSavedState, "url" | "simulation" | "id" | "uuid"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    saved_state: value["savedState"],
  };
}
